import {createBrowserHistory} from 'history';

export const history = createBrowserHistory();

export function getHistory() {
  return history;
}
